// extracted by mini-css-extract-plugin
module.exports = {"thumbnails-component":"Thumbnails_thumbnails-component__PCel9","swiper-slide":"Thumbnails_swiper-slide__prE1g","slide":"Thumbnails_slide__XZWxh"};